module.exports = __webpack_public_path__ + "static/img/yizhangtu_01.9340a06.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yizhangtu_01.png
// module id = X2KF
// module chunks = 1